import { useQuery, UseQueryResult } from "react-query";
import { getRegistrosList } from "@/services/registros";
import { QueryKey } from "@/configs/queryKeys";
import { IRegistrosResultado } from "@/interfaces/registros";

export function useGetRegistrosList({
  params
}): UseQueryResult<IRegistrosResultado> {
  return useQuery([QueryKey.registrosList, { params }], getRegistrosList, {
    staleTime: 1000 * 60 * 60 * 24, // 1 day,
    keepPreviousData: true,
    cacheTime: 10 * (60 * 1000), // 10 mins
    retry: false,
    refetchOnReconnect: false,
    enabled: !!params.idEmpregador
  })
}
